export default __webpack_public_path__ + "static/media/closet5-after1-2048w.63b3af6d.png";